// import React from 'react';
import React, { Suspense } from 'react';
import { message, Spin } from 'antd';
import { deepCopy, isMobile, isWxWorkBrowser, matchQuery, urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
// import { Routes, Route } from 'react-router-dom';
import Login from '@/layout/components/Login';
import ForgetPassword from '@/views/password/pages/index/entry';
import PDF from '@/views/pdf/pages/index/entry';
import ShareIndustry from '@/views/selection/pages/shareindustry/entry';
import { getCookie, removeCookie } from '@lhb/cache';
import { isDDEnv, isLarkEnv, isWeComEnv } from '@/common/utils/ways';
import { handleInterceptInLark, targetMsgPath } from '@/common/utils/lark';
import { ContentType } from '@/views/youth/pages/map/custom_KA/ka-config';
import { checkValidToken } from '@/common/api/common';
// import { useAliveController } from 'react-activation';
// import { keepRoutes } from './keep-alive-config';
import MassImage from '@/views/massimage/pages/index/entry';
import LCNSiteMap from '@/views/lcn/pages/sitemap/entry';
import ShareSpotEvaluation from '@/views/spotevaluation/pages/detail/entry';
import DingLogin from '@/views/dev/pages/dinglogin/entry'; // demo
import DDExemption from '@/views/dd/pages/exemption/entry'; // 钉钉免登页(正式应用)
import ShareFailure from '@/views/share/pages/failure/entry'; // 分享失效页
import ShareSiteselectionmapb from '@/views/share/pages/siteselectionmapb/entry'; // 选址地图页详情页
import ShareYouth from '@/views/share/pages/youth/entry';
import FeishuExemption from '@/views/feishu/pages/exemption/entry';
// import Approver from '@/views/expandstore/pages/approver/entry';
import Spotsurveydetail from 'src/views/expandstore/pages/spotsurveydetail/entry';
import Spotdetail from 'src/views/expandstore/pages/spotdetail/entry';
import XTCQWCode from '@/views/xtc/pages/qwcode/entry';
import XTCWeComExemption from '@/views/xtc/pages/exemption/entry';
import ALQOfLogin from '@/views/microsoft/pages/alq/entry';
import ALQOfExemption from '@/views/microsoft/pages/exemption/entry';
import Chancepointdetail from '@/views/expandstore/pages/chancepointdetail/entry';
import MallReportShare from '@/views/share/pages/mallreport/entry';
import {
  buildLocxxExpansionInsightRedirectUrl,
  getLocxxExpansionPcAction,
  getLocxxExpansionPageCleanPath,
  getLocxxExpansionPageScene,
  isLocxxExpansionTaskMessage,
} from '@/common/config/locxxExpansion';
import LocxxTenantSwitchGate from './LocxxTenantSwitchGate';
import ShareYMDecision from '@/views/share/pages/ymdecision/entry';
import { getMallReportShareRedirectUrl } from './mall-report-share-redirect';
let locationFrom: any = {
  pathname: null,
  search: null,
};
const clObj = {
  from: '',
  to: ''
};

// 无需登录访问的页面（注意有些事是完整的pathname、有些只是部分的pathname）
// const dispenseWithAuthentication = [
//   '/pdf/', // 渲染pdf的相关页面
//   '/openweb', // 协议相关页面
// ];
async function checkToken(tokenStr: string, shareId: string) {
  try {
    await checkValidToken({ token: tokenStr }, { needHint: false });
    // 跳到移动端首页
    const targetUrl = `${process.env.INSIGHT_URL}/home`;
    window.location.replace(targetUrl || '/');
  } catch (error) {
    removeCookie('flow_token');
    removeCookie('flow_share_token');
    // 未登录：跳到移动端登录页
    const targetUrl = `${process.env.INSIGHT_URL}/login?shareId=${shareId}`;
    window.location.replace(targetUrl || '/');
  }
}
/**
 * 路由守卫
 * @description 用于处理短链跳转。
 * 注意，如果是直接 return 组件，那么该组件不会走 app.tsx 的渲染流程，也不会被 Layout 包裹，就执行不到 UserInfoContextProvider，子组件会拿不到 useContext(UserInfoContext)，需要在 return 的组件内使用 BasicLayout 包裹 UserInfoContextProvider。
 * @param param0
 * @returns
 */
const RouterControl: React.FC<{
  locationTo: any;
  routeList: Array<any>;
}> = ({ children, locationTo, routeList }) => {
  // const { clear } = useAliveController();
  const methods = useMethods({
    routerAfterEach(from: any, to: any) {
      clObj.from = from;
      clObj.to = to;
      const title = routeList.find((item) => {
        return item.path === to.pathname;
      })?.meta?.title;
      if (!title) {
        const ignorePaths = ['/']; // 不提示添加title的特殊页面路由
        process.env.NODE_ENV === 'development' && !ignorePaths.includes(to.pathname) && message.error('为了方便数据采集，请添加title！');
      } else {
        document.title = `${title}`; // 具体页面名称(不加项目名，潜水让拿掉)
      }
      // if (from?.pathname && to?.pathname) {
      //   const needClear = keepRoutes.every(item => {
      //     const matching = !item.formPathname.includes(from.pathname) || !item.toPathname.includes(to.pathname);
      //     const matchingReverse = !item.formPathname.includes(to.pathname) || !item.toPathname.includes(from.pathname);
      //     return matching && matchingReverse;
      //   });
      //   needClear && clearAlive();
      // }
      if (process.env.NODE_ENV !== 'development') {
        // 大数据埋点，先发送离开页面的信息 再上传进入页面的信息
        window.LHBbigdata.spa.beforeRouteLeave()(to, from);
        window.LHBbigdata.spa.beforeRouteEnter()(to, from);
      }
    },
  });
  const mallReportShareRedirectUrl = getMallReportShareRedirectUrl({
    pathname: locationTo.pathname,
    search: locationTo.search,
    hash: locationTo.hash,
    shouldRedirect: isMobile(),
    targetBaseUrl: process.env.INSIGHT_URL,
    currentOrigin: window.location.origin,
  });
  if (mallReportShareRedirectUrl) {
    window.location.replace(mallReportShareRedirectUrl);
    return null;
  }
  if (locationTo.pathname !== locationFrom.pathname || locationTo.search !== locationFrom.search) {
    // fullPath完全改变才会触发
    // 为大数据埋点设置fullPath，path
    methods.routerAfterEach({
      ...locationFrom,
      fullPath: locationFrom.pathname ? locationFrom.pathname + locationFrom.search : '/',
      path: locationFrom.pathname || '/',
    }, {
      ...locationTo,
      fullPath: locationTo.pathname + locationTo.search,
      path: locationTo.pathname,
    // }, routeList, clear);
    });
  }
  // 提前备份location数据
  const location = {
    to: locationTo,
    from: locationFrom,
  };
  locationFrom = deepCopy(locationTo);
  let isShareUrl = false; // 如果shareId参数存在，就代表是处于分享页
  try {
    if (matchQuery(window.location.href, 'shareId')) {
      isShareUrl = true;
    } else if (window.parent?.location?.href && matchQuery(window.parent.location.href, 'shareId')) { // 父窗口嵌套
      isShareUrl = true;
    }
  } catch (err) {}
  //  登录鉴权
  const token = isShareUrl ? getCookie('flow_share_token') : getCookie('flow_token');

  // Locxx 拓店任务消息仅在场景、模板、任务和租户参数完整时进入移动端租户切换分发，其他 RouterControl 分支保持原样。
  const locxxExpansionMessageParams = urlParams(locationTo.search);
  if (
    isMobile() &&
    process.env.INSIGHT_URL &&
    isLocxxExpansionTaskMessage(locationTo.pathname, locxxExpansionMessageParams)
  ) {
    const redirectUrl = buildLocxxExpansionInsightRedirectUrl(
      process.env.INSIGHT_URL,
      locxxExpansionMessageParams
    );
    if (redirectUrl) window.location.href = redirectUrl;
    return null;
  }
  if (
    isMobile() &&
    process.env.INSIGHT_URL &&
    getLocxxExpansionPageScene(locationTo.pathname, locxxExpansionMessageParams)
  ) {
    const redirectUrl = buildLocxxExpansionInsightRedirectUrl(
      process.env.INSIGHT_URL,
      locxxExpansionMessageParams,
    );
    if (redirectUrl) window.location.href = redirectUrl;
    return null;
  }

  const locxxExpansionPcAction = !isMobile()
    ? getLocxxExpansionPcAction(
      locationTo.pathname,
      locationTo.search,
      getCookie('tenantId'),
      token,
      locationTo.hash,
    )
    : null;
  if (locxxExpansionPcAction?.type === 'switchTenant') {
    return <LocxxTenantSwitchGate
      tenantId={locxxExpansionPcAction.tenantId}
      originUrl={locxxExpansionPcAction.originUrl}
    />;
  }
  if (locxxExpansionPcAction?.type === 'fallback') {
    window.location.replace('/');
    return null;
  }
  if (locxxExpansionPcAction?.type === 'render') {
    const cleanPath = getLocxxExpansionPageCleanPath(
      locationTo.pathname,
      locationTo.search,
      locationTo.hash,
    );
    if (cleanPath) window.history.replaceState(window.history.state, '', cleanPath);
  }

  // 移动端
  // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  // if (token && isMobile) { // 包含token信息移动端跳转
  //   window.location.href = 'https://locationweb2b.lanhanba.net';
  // }

  // 前端白名单
  // pdf导航页
  if (locationTo.pathname === '/pdf') return <PDF/>;
  // 行业地图分享页
  if (locationTo.pathname === '/selection/shareindustry') return <ShareIndustry/>;
  // 海量点图片处理页面
  if (locationTo.pathname === '/massimage') return <MassImage/>;
  // 邻汇吧选址地图
  if (locationTo.pathname === '/lcn/sitemap') return <LCNSiteMap location={location}/>;
  // 临时demo
  if (locationTo.pathname === '/dev/dinglogin') return <DingLogin />;
  // 钉钉免登（正式）
  if (locationTo.pathname === '/dd/exemption') return <DDExemption />;
  // 飞书免登
  if (locationTo.pathname === '/feishu/exemption') return <FeishuExemption />;
  // 分享失效页
  if (locationTo.pathname === '/share/mallreport') return <MallReportShare/>;
  if (locationTo.pathname === '/share/failure') return <ShareFailure/>;
  // 一鸣决策报告-分享页
  if (locationTo.pathname === '/share/ymdecision') {
    // H5环境内时跳转到H5页面
    if (isMobile()) {
      window.location.href = `${process.env.INSIGHT_URL}/share/ymdecision${locationTo.search}`;
      return null;
    }
    return <ShareYMDecision/>;
  }
  // 选址地图青春版-分享
  if (locationTo.pathname === '/share/youth') {
    // H5环境内时跳转到H5页面
    if (isMobile()) {
      window.location.href = `${process.env.INSIGHT_URL}/share/youth${locationTo.search}`;
      return null;
    }
    return <ShareYouth/>;
    // /iterate/siteselectionmapdetail?areaId=4279314&modelId=5
  }
  // 选址地图-开店区域详情分享页-pc
  if (locationTo.pathname === '/share/siteselectionmapb') {
    if (isMobile()) {
      // 选址地图-开店区域详情分享页-app
      window.location.href = `${process.env.INSIGHT_URL}/iterate/siteselectionmapdetail${locationTo.search}`;
      return null;
    // /iterate/siteselectionmapdetail?areaId=4279314&modelId=5
    }
    return <ShareSiteselectionmapb/>;
  }

  // 机会点详情页
  if (locationTo.pathname === '/expandstore/chancepointdetail') {
    if (isMobile()) {
      // 机会点详情-app
      window.location.href = `${process.env.STORE_ASSISTANT_URL}/standardstore/chancepointdetail${locationTo.search}`;
      return null;
    }
    return <Chancepointdetail/>;
  }

  // 踩点记录详情-pc
  // http://10.10.8.25:3000/expandstore/spotsurveydetail?id=16746
  if (locationTo.pathname === '/expandstore/spotsurveydetail') {
    if (isMobile()) {
      // 踩点记录详情-app
      window.location.href = `${process.env.STORE_ASSISTANT_URL}/spotsurvey/detail${locationTo.search}`;
      return null;
    }
    return <Spotsurveydetail/>;
  }

  // 客流计数-点位详情-pc
  // http://10.10.8.25:3000/expandstore/spotdetail?id=1425
  if (locationTo.pathname === '/expandstore/spotdetail') {
    if (isMobile()) {
      // 点位详情-app
      window.location.href = `${process.env.INSIGHT_URL}/passenger/taskdetail${locationTo.search}`;
      return null;
    }
    return <Spotdetail/>;
  }

  // 点位测评分享页
  if (isMobile() && locationTo.pathname === '/spotevaluation/detail' && process.env.INSIGHT_URL) {
    window.location.href = `${process.env.INSIGHT_URL}/spotevaluation/detail${locationTo.search}`;
  }
  if (locationTo.pathname === '/spotevaluation/detail') return <ShareSpotEvaluation/>;

  // pdf相关页（含本地 /pdf/ymdecisionpdf 调试入口），请求鉴权均沿用 getHeader 读取 URL token。
  if (locationTo.pathname.indexOf('/pdf/') !== -1) {
    const pdfRoutes = routeList.filter((route: any) => route.path.indexOf('/pdf/') !== -1);
    const targetRouter = pdfRoutes.find((item: any) => item.path === locationTo.pathname);
    if (targetRouter) {
      const TargetCom: any = targetRouter.component;
      return (
        <Suspense fallback={<Spin />}>
          <TargetCom />
        </Suspense>
      );
    }
  }

  // 协议相关页面无需登录
  if (locationTo.pathname.indexOf('/openweb') !== -1) {
    const pdfRoutes = routeList.filter((route: any) => route.path.indexOf('/openweb') !== -1);
    const targetRouter = pdfRoutes.find((item: any) => item.path === locationTo.pathname);
    if (targetRouter) {
      const TargetCom: any = targetRouter.component;
      return (
        <Suspense fallback={<Spin />}>
          <TargetCom />
        </Suspense>
      );
    }
  }

  // 图片相关页面无需登录
  if (locationTo.pathname.indexOf('/imageserve/') !== -1) {
    const imageRoutes = routeList.filter((route: any) => route.path.indexOf('/imageserve/') !== -1);
    const targetRouter = imageRoutes.find((item: any) => item.path === locationTo.pathname);
    if (targetRouter) {
      const TargetCom: any = targetRouter.component;
      return (
        <Suspense fallback={<Spin />}>
          <TargetCom />
        </Suspense>
      );
    }
  }
  // 未登录时打开了飞书审批消息/拓店任务
  if (isLarkEnv() && targetMsgPath.includes(locationTo.pathname)) {
    if (isMobile()) { // 移动端打开该消息链接时，跳转到移动端地址
      // 这里不区分是否登录，由area-insight的飞书免登页统一处理
      const params = urlParams(window.location.search);
      const { mobileRouter, typeValue, appId, appID } = params || {};
      if (mobileRouter) {
        let taregtUrl = `${process.env.STORE_ASSISTANT_URL}${mobileRouter}${window.location.search}`;
        if (typeValue === '16' || typeValue === '19') { // 字段为string类型
          taregtUrl = `${process.env.INSIGHT_URL}${mobileRouter}${window.location.search}`;
        }
        window.location.replace(`${process.env.INSIGHT_URL}/feishu/exemption?appID=${appId || appID}&originUrl=${encodeURIComponent(taregtUrl)}`);
        return null;
      }
      window.location.href = `${process.env.INSIGHT_URL}/feishu/exemption${window.location.search}`;
      return <></>;
    }

    if (!token) { // 如果还未登录过，在参数满足条件的情况下进行免登重定向到对应的消息页
      handleInterceptInLark();
    }
  }

  // 未登录时打开了钉钉审批消息/拓店任务
  if (isDDEnv() && targetMsgPath.includes(locationTo.pathname)) {
    if (isMobile()) { // 移动端打开该消息链接时，跳转到移动端地址
      // 这里不区分是否登录，由area-insight的钉钉免登页统一处理
      const params = urlParams(window.location.search);
      const { mobileRouter, typeValue, corpId, clientId } = params || {};
      if (mobileRouter) {
        let taregtUrl = `${process.env.STORE_ASSISTANT_URL}${mobileRouter}${window.location.search}`;
        if (typeValue === '16' || typeValue === '19') { // 字段为string类型
          taregtUrl = `${process.env.INSIGHT_URL}${mobileRouter}${window.location.search}`;
        }
        // 消息跳转时，不设置dd_full_screen=true
        window.location.replace(`${process.env.INSIGHT_URL}/dd/authorization?corpId=${corpId}&clientId=${clientId}&originUrl=${encodeURIComponent(taregtUrl)}`);
        return null;
      }
      window.location.href = `${process.env.INSIGHT_URL}/dd/authorization${window.location.search}`;
      return <></>;
    }
    // PC
    if (!token) { // 未登录时，跳转钉钉
      window.location.replace(`${process.env.CONSOLE_PC_URL}/dd/exemption${window.location.search}&originUrl=${encodeURIComponent(window.location.href)}`);
      return <></>;
      // /dd/exemption process.env.CONSOLE_PC_URL
    }
  }

  // 处理在移动端打开pc链接，而且还是SaaS后台分享配置的场景
  if (isMobile() && window.location.pathname === '/' && urlParams(locationTo.search)?.shareId) {
    const { shareId } = urlParams(locationTo.search);
    // 还处于登录有效期内
    if (token) {
      // 校验token是否有效
      checkToken(token, shareId);
      return null;
    }
    // 未登录：跳到移动端登录页
    const targetUrl = `${process.env.INSIGHT_URL}/login?shareId=${shareId}`;
    window.location.replace(targetUrl || '/');
    return null;
  }
  // 奥乐齐登录页
  if (!token && locationTo.pathname === '/microsoft/alq') {
    return <ALQOfLogin/>;
  }
  // 奥乐齐免登页
  if (locationTo.pathname === '/microsoft/exemption') {
    return <ALQOfExemption/>;
  }

  // 没有登录且不在忘记密码页面则显示登录
  if (!token && locationTo.pathname !== '/password') {
    // 如果是小天才部署环境的话，小天才独有的扫码登录(https://confluence.lanhanba.com/pages/viewpage.action?pageId=149544093)
    if (process.env.CUSTOMIZED_PROJECT === ContentType.XTC) {
      // 给Location的人自己留的口子
      if (locationTo.pathname === '/loc/login') {
        return <Login />;
      }
      // 企微环境下时，走免登
      if (isWeComEnv()) {
        return <XTCWeComExemption/>;
      }
      return <XTCQWCode/>;
    }
    return <Login />;
  }
  // 没有登录且在忘记密码页面则显示忘记密码页面
  if (!token && locationTo.pathname === '/password') return <ForgetPassword />;

  // 在企微内打开需要判断设备跳转
  if (token && isMobile() && isWxWorkBrowser() && process.env.STORE_ASSISTANT_URL && process.env.INSIGHT_URL) {
    const params = urlParams(locationTo.search);
    if (params.id && params.mobileRouter) {
      // 集客点(网规和选址)
      if (params.typeValue === '16' || params.typeValue === '19') { // 字段为string类型
        // 集客点审批需要跳转到area-insight项目中----mobileRouter只有审批消息才有
        window.location.href = `${process.env.INSIGHT_URL}${params.mobileRouter}?id=${params.id}`;
        return null;
      }
      window.location.href = `${process.env.STORE_ASSISTANT_URL}${params.mobileRouter}?id=${params.id}`;
      return null;
    } else if (!params.id && params.mobileRouter) {
      window.location.href = `${process.env.STORE_ASSISTANT_URL}${params.mobileRouter}`;
      return null;
    } else {
      window.location.href = process.env.INSIGHT_URL + `/home`;
      return null;
    }
  }

  return (
    <>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child as React.ReactElement, {
          location,
        });
      })}
    </>
  );
};

export default RouterControl;
